import { defineStore as _defineStore} from './abstractstore'
import { useConfig, deepMerge } from "@/plugins/obscore"

const Models = require.context('@/models/', true, /.*/i);

export default class AbstractStoreManager {
    stores = {}
    defineStore(storeName) {
        const config = Models(`./${storeName}.json`)
        const defaults = useConfig().model

        config.baseApiUrl = config.baseApiUrl ? config.baseApiUrl : defaults.baseApiUrl
        config.baseApiHost = config.baseApiHost ? config.baseApiHost : defaults.baseApiHost
        if (!config.apis) {
            config.apis = {}
        }
        let apiBase = config.apiBase?config.apiBase:storeName
        for (let api in defaults.apis) {
            if (!config.apis[api]) {
                config.apis[api] = `${config.baseApiUrl}/${apiBase}${defaults.apis[api]}`
            }
        }

        if (!config.fields) {
            config.fields = {}
        }
        for (let field in config.fields) {
            config.fields[field] = deepMerge(defaults.fields, config.fields[field], false)
        }

        // this.stores[storeName] = new AbstractStore(storeName, config)
        const store = _defineStore(storeName, {
            state: config
        })

        this.stores[storeName] = store
    }
    useStore(storeName) {
        if (!this.stores[storeName])
            this.defineStore(storeName)

        return this.stores[storeName]
    }
}